import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00f5143a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tour-select-step" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-horizontal" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-horizontal" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TourSelectSelectedTourDate = _resolveComponent("TourSelectSelectedTourDate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTours, ({
        tourId,
        dateString,
        dayOfTheWeek,
        location,
        isHoliday,
      }) => {
      return (_openBlock(), _createElementBlock("div", { key: tourId }, [
        _createVNode(_component_TourSelectSelectedTourDate, {
          "date-string": dateString,
          "day-of-the-week": dayOfTheWeek,
          location: location,
          "is-holiday": isHoliday
        }, null, 8, ["date-string", "day-of-the-week", "location", "is-holiday"]),
        _hoisted_3
      ]))
    }), 128))
  ]))
}